<template>
  <el-container>
    <RouterView />
  </el-container>
</template>

<script>
// eslint-disable-next-line import/no-webpack-loader-syntax
import iframeResizerContentWindowScript from '!raw-loader!iframe-resizer/js/iframeResizer.contentWindow.js'

export default {
  data () {
    return {
      iframeResizerContentWindow: undefined
    }
  },
  mounted () {
    if (typeof this.iframeResizerContentWindow === 'undefined') {
      this.iframeResizerContentWindow = document.createElement('script')
      this.iframeResizerContentWindow.type = 'text/javascript'
      this.iframeResizerContentWindow.text = iframeResizerContentWindowScript

      document.head.appendChild(this.iframeResizerContentWindow)
    }
  },
  beforeDestroy () {
    if (typeof this.iframeResizerContentWindow !== 'undefined') {
      this
        .iframeResizerContentWindow
        .parentNode
        .removeChild(this.iframeResizerContentWindow)

      this.iframeResizerContentWindow = undefined
    }
  }
}
</script>

<style lang="scss">
 html, body {
   background-color: #f5f5f5;
 }
</style>
